import type { FC } from 'react';
import { useStore } from 'zustand';

import { ModalHeader } from 'Features/SellerCommunications/components/ModalHeader';
import { EnquiriesSearchStore } from 'Features/SellerCommunications/services';
import { T } from 'Features/SellerCommunications/utils/translate';

import styles from './EnquirySelectionList.module.scss';

export const EnquirySelectionListNotFound: FC = () => {
	const noResults = useStore(EnquiriesSearchStore, (state) => state.noResults);

	return noResults ? (
		<div className={styles.notFound}>
			<ModalHeader
				description={T.translate('enquiryList.notFoundDescription')}
				title={T.translate('enquiryList.notFoundTitle')}
			/>
		</div>
	) : null;
};
